import {
  DestroyRef,
  Directive,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { fromEvent, Subscription, merge } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[clickOutside]',
  standalone: true,
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter();
  @Input() set actived(value: boolean) {
    this.subscription?.unsubscribe();
    if (value) requestAnimationFrame(() => this.addEvent());
  }
  @Input() customElementRef: ElementRef | null = null;
  @Input() ignoreSelectors: string[] = [];
  public elementRef = inject(ElementRef);
  public subscription: Subscription | null = null;
  private destroyRef = inject(DestroyRef);

    private addEvent(): void {
        this.subscription?.unsubscribe();

        const click$ = fromEvent<MouseEvent>(document, 'click');
        const rightClick$ = fromEvent<MouseEvent>(document, 'contextmenu');


        this.subscription = merge(click$, rightClick$)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
            if (!event?.target) return;

            const target = event.target as HTMLElement;

            const shouldIgnore = this.ignoreSelectors?.some(selector => {
                if (target.matches(selector)) return true;
                if (target.closest(selector)) return true;

                const elements = document.querySelectorAll(selector);
                return Array.from(elements).some(element => element.contains(target));
            });

            if (shouldIgnore) return;

            const elementRef = this.customElementRef ?? this.elementRef;

            const clickedInside = elementRef.nativeElement.contains(target);

            if (!clickedInside) {
                this.clickOutside.emit(event);
                this.subscription?.unsubscribe();
            }
        });
    }
}
